import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Download, FileText } from 'lucide-react'
import { useState } from 'react'

interface PdfViewerProps {
  pdfUrl: string | null
  invoiceNumber: string
  loading: boolean
}

export const PdfViewer = ({ pdfUrl, invoiceNumber, loading }: PdfViewerProps) => {
  console.log('PdfViewer render', { pdfUrl, invoiceNumber, loading })
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)

  if (loading) {
    return (
      <Card>
        <CardContent className="flex flex-col items-center justify-center py-12">
          <FileText className="h-12 w-12 text-muted-foreground mb-4" />
          <p className="text-muted-foreground">Laddar PDF...</p>
        </CardContent>
      </Card>
    )
  }
  if (!pdfUrl) {
    return (
      <Card>
        <CardContent className="flex flex-col items-center justify-center py-12">
          <FileText className="h-12 w-12 text-muted-foreground mb-4" />
          <p className="text-muted-foreground">Ingen PDF tillgänglig för denna faktura</p>
        </CardContent>
      </Card>
    )
  }

  const handleDownload = () => {
    window.open(pdfUrl, '_blank')
  }

  return (
    <Card className="flex flex-col">
      <CardContent className="p-0 flex-grow flex flex-col">
        <div className="flex items-center justify-between p-4 border-b">
          <div className="flex items-center gap-2">
            <FileText className="h-5 w-5" />
            <span className="font-medium">Faktura {invoiceNumber}</span>
          </div>
          <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" onClick={handleDownload}>
              <Download className="h-4 w-4 mr-2" />
              Ladda ner
            </Button>
          </div>
        </div>
        <div className="relative w-full bg-muted/30 flex-grow" style={{ minHeight: '80vh' }}>
          <iframe
            src={`${pdfUrl}#page=${currentPage}`}
            className="absolute inset-0 w-full h-full"
            title={`Invoice ${invoiceNumber} - Page ${currentPage}`}
            onLoad={e => {
              // Attempt to detect total pages (limited by browser security)
              // This is a basic implementation - actual page count detection
              // would require PDF.js or similar library
              setTotalPages(1)
            }}
          />
        </div>
      </CardContent>
    </Card>
  )
}
